// The number of required clicks on a secret element to enter debug mode
export const CLICKS_FOR_DEBUG_MODE = 7;
// The number of samples per second coming from a connected sensor
export const SENSOR_SAMPLE_RATE = 100;
// The maximum milliseconds before stopping recording
export const MAX_RECORDING_TIME = 60 * 1000; // 60 seconds
// The number of play steps per second
export const PLAY_STEPS_PER_SECOND = 10;
// RootStore storage key
export const ROOT_STATE_STORAGE_KEY = 'rootStore';

export const SERVER_URL_ALPHA = 'https://spinnax.venditti.de';
export const SERVER_URL_BETA = 'https://api.spinnax.com';
export const RANKER_URL = 'https://ranker.spinnax.com';
export const SHARING_URL = 'https://app.spinnax.com/record';
export const AGENT_URL = 'https://agent.spinnax.com';
export const CLASSIFIER_URL = 'https://classifier.spinnax.com';
export const VIDEO_URL = 'https://video.spinnax.com';

/* Interval in ms to check for a valid license (only used to communicate to the User) */
export const LICENSE_CHECK_INTERVAL = 10 * 60 * 1000; // 10 Minutes

// export const FIRMWARE_SERVER_URL = `${SERVER_URL_BETA}/firmware_update_from_version`;
// export const API_URL = `${SERVER_URL_BETA}/v_1`;
// export const PROCESS_URL = `${API_URL}/Record/process`;
// export const ESTIMATOR_URL_1 = 'https://spinnax.venditti.de';
// export const ESTIMATOR_URL_2 = 'https://estimator.spinnax.com';

export const MESSAGE_ALIVE_MS = 5000;
export const MESSAGE_POSITION = 'top';